export default "__VITE_ASSET__ByT7o8yG__"